module.exports = __webpack_public_path__ + "static/media/020_g2-1 Join Gigable v2.51b91b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/020_g2-1 Join Gigable v2.png
// module id = 443
// module chunks = 0